import React from "react"

const Map = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.4613 4.65845C21.3714 4.58845 21.2668 4.53982 21.1554 4.51627C21.0439 4.49272 20.9286 4.49485 20.8181 4.52251L15.0872 5.95501L9.33563 3.07876C9.17537 2.99883 8.99181 2.97888 8.81812 3.02251L2.81812 4.52251C2.65587 4.56307 2.51183 4.6567 2.40889 4.78851C2.30595 4.92033 2.25003 5.08277 2.25 5.25001V18.75C2.25002 18.864 2.27601 18.9764 2.32599 19.0789C2.37598 19.1813 2.44864 19.271 2.53847 19.3411C2.62831 19.4112 2.73294 19.4599 2.84442 19.4836C2.95591 19.5072 3.07131 19.5051 3.18187 19.4775L8.91281 18.045L14.6644 20.9213C14.7688 20.9727 14.8836 20.9997 15 21C15.0613 21 15.1224 20.9924 15.1819 20.9775L21.1819 19.4775C21.3441 19.437 21.4882 19.3433 21.5911 19.2115C21.694 19.0797 21.75 18.9173 21.75 18.75V5.25001C21.75 5.13594 21.724 5.02337 21.674 4.92086C21.624 4.81835 21.5512 4.7286 21.4613 4.65845ZM9.75 4.96314L14.25 7.21314V19.0369L9.75 16.7869V4.96314ZM3.75 5.83595L8.25 4.71095V16.6641L3.75 17.7891V5.83595ZM20.25 18.1641L15.75 19.2891V7.33595L20.25 6.21095V18.1641Z"
        fill="#1F1F23"
      />
    </svg>
  )
}

export default Map
